import React, { useState } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import ColorPickerModal from './ColorPickerModal';
import { trackColorPickerOpen, trackColorPickerClose } from '../utils/analytics';

const ColorPickerControl = ({ 
    color, 
    onChange, 
    onPresetClick 
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => {
        setIsOpen(true);
        trackColorPickerOpen();
    };

    const handleClose = () => {
        setIsOpen(false);
        trackColorPickerClose();
    };

    const styles = {
        color: {
            width: '38px',
            height: '38px',
            borderRadius: '8px',
            background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
            border: '2px solid rgba(255,255,255,0.8)',
            transition: 'all 0.2s ease',
        },
        swatch: {
            padding: '4px',
            background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            height: '48px',
            minWidth: '48px',
            border: '2px solid transparent',
            transition: 'all 0.3s ease',
            position: 'relative',
            overflow: 'hidden',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(0,0,0,0.2), 0 4px 8px rgba(0,0,0,0.15)',
                border: '2px solid #e8632d',
            },
            '&:active': {
                transform: 'translateY(0px)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            }
        }
    };

    return (
        <>
            <Box sx={styles.swatch} onClick={handleOpen}>
                <Box sx={styles.color} />
            </Box>
            <ColorPickerModal
                open={isOpen}
                onClose={handleClose}
                color={color}
                onColorChange={onChange}
                onPresetClick={onPresetClick}
            />
        </>
    );
};

ColorPickerControl.propTypes = {
    color: PropTypes.shape({
        r: PropTypes.number,
        g: PropTypes.number,
        b: PropTypes.number,
        a: PropTypes.number
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onPresetClick: PropTypes.func.isRequired
};

export default ColorPickerControl;

